module.exports = __webpack_public_path__ + "img/messages_notification_white.1e91a4a1.svg";